import React from 'react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import { checkPermissions } from 'hooks';
import { connect } from 'react-redux';
import PageSpinner from 'components/PageSpinner';
import { getToken } from 'hooks/storage';
import ScreenContext from 'context/screen-context';



const MainComponent = (props) => {

    const screen = React.useContext(ScreenContext);

    const [loading, setLoading] = React.useState(true);
    const firstRender = React.useRef(true);
    const handleLoaders = () => {
        setLoading(false)
    }

    const requestInterceptor = (req) => {


        let authToken = (req.headers && req.headers.Authorization) ? req.headers.Authorization : `Bearer ${getToken()}`;
        if (firstRender.current) {
            firstRender.current = false;
            return (
                {
                    ...req,
                    headers: {
                        Authorization: `${authToken}`
                    }
                }
            )
        } else {
            return req;
        }
    };


    return (
        <div className="swagger-ui-div" style={{ maxWidth: screen.width }}>

            {checkPermissions(props.loginData, 'api_documentation') ?
                <div className={(!loading) && 'swagger-ui-box'}>
                    {(loading) && <PageSpinner style={{ height: '10vh', position: 'absolute' }} />}
                    <SwaggerUI
                        url={`${props.url}`}
                        onComplete={handleLoaders}
                        requestInterceptor={requestInterceptor} />
                </div>
                : <div style={{ textAlign: 'center', marginTop: 50 }}>You are not authorize to access this page</div>}
        </div>
    );
};

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});


const ApiMainComponent = connect(mapStateToProps)(MainComponent);

export default ApiMainComponent;
